module.exports = __webpack_public_path__ + "static/media/checking-phone.834846c6.svg";